// See https://github.com/acdlite/flux-standard-action

// Nav
export const NAV_ACTIVATE = 'NAV_ACTIVATE';
export const NAV_ENABLE = 'NAV_ENABLE';
export const NAV_RESPONSIVE = 'NAV_RESPONSIVE';
export const NAV_CONTROLFLOAT = 'NAV_CONTROLFLOAT';

// Action Center
export const ACTIONCENTER_LOAD = 'ACTIONCENTER_LOAD';
export const ACTIONCENTER_UNLOAD = 'ACTIONCENTER_UNLOAD';
export const ACTIONCENTER_SET = 'ACTIONCENTER_SET';

// Executive Dashboard
export const EXECUTIVEDASHBOARD_LOAD = 'EXECUTIVEDASHBOARD_LOAD';
export const EXECUTIVEDASHBOARD_UNLOAD = 'EXECUTIVEDASHBOARD_UNLOAD';
export const EXECUTIVEDASHBOARD_SET = 'EXECUTIVEDASHBOARD_SET';

// Master Calibrator
export const MASTERCALIBRATOR_LOAD = 'MASTERCALIBRATOR_LOAD';
export const MASTERCALIBRATOR_UNLOAD = 'MASTERCALIBRATOR_UNLOAD';
export const MASTERCALIBRATOR_SET = 'MASTERCALIBRATOR_SET';

// Survey
export const AGENTSURVEY_LOAD = 'AGENTSURVEY_LOAD';
export const AGENTSURVEY_UNLOAD = 'AGENTSURVEY_UNLOAD';
export const AGENTSURVEY_SET = 'AGENTSURVEY_SET';

// Calibrator Survey Selector
export const CALIBRATORSURVEYSELECTOR_LOAD = 'CALIBRATORSURVEYSELECTOR_LOAD';
export const CALIBRATORSURVEYSELECTOR_UNLOAD = 'CALIBRATORSURVEYSELECTOR_UNLOAD';
export const CALIBRATORSURVEYSELECTOR_SET = 'CALIBRATORSURVEYSELECTOR_SET';

// QA Engine
export const QACALLSUGGESTIONS_LOAD = 'QACALLSUGGESTIONS_LOAD';
export const QACALLSUGGESTIONS_UNLOAD = 'QACALLSUGGESTIONS_UNLOAD';
export const QACALLSUGGESTIONS_SET = 'QACALLSUGGESTIONS_SET';

// Agent Scorecard
export const SCORECARD_LOAD = 'SCORECARD_LOAD';
export const SCORECARD_UNLOAD = 'SCORECARD_UNLOAD';
export const SCORECARD_SET = 'SCORECARD_SET';

// Users View
export const USERSVIEW_LOAD = 'USERSVIEW_LOAD';
export const USERSVIEW_UNLOAD = 'USERSVIEW_UNLOAD';
export const USERSVIEW_SELECTUSER = 'USERSVIEW_SELECTUSER';
export const USERSVIEW_POSTUSER = 'USERSVIEW_POSTUSER';
export const USERSVIEW_SET = 'USERSVIEW_SET';

// Teams View
export const TEAMSVIEW_LOAD = 'TEAMSVIEW_LOAD';
export const TEAMSVIEW_UNLOAD = 'TEAMSVIEW_UNLOAD';
export const TEAMSVIEW_SELECTTEAM = 'TEAMSVIEW_SELECTTEAM';
export const TEAMSVIEW_POSTTEAM = 'TEAMSVIEW_POSTTEAM';
export const TEAMSVIEW_SET = 'TEAMSVIEW_SET';

// Customer Groups View
export const CUSTOMERGROUPSVIEW_LOAD = 'CUSTOMERGROUPSVIEW_LOAD';
export const CUSTOMERGROUPSVIEW_UNLOAD = 'CUSTOMERGROUPSVIEW_UNLOAD';
export const CUSTOMERGROUPSVIEW_SELECT = 'CUSTOMERGROUPSVIEW_SELECT';
export const CUSTOMERGROUPSVIEW_POST = 'CUSTOMERGROUPSVIEW_POST';
export const CUSTOMERGROUPSVIEW_SET = 'CUSTOMERGROUPSVIEW_SET';

//File Uploader
export const FILEUPLOADER_LOAD = 'FILEUPLOADER_LOAD';
export const FILEUPLOADER_UNLOAD = 'FILEUPLOADER_UNLOAD';
export const FILEUPLOADER_SET = 'FILEUPLOADER_SET';

// Image Cropper
export const IMAGECROPPER_LOAD = 'IMAGECROPPER_LOAD';
export const IMAGECROPPER_UNLOAD = 'IMAGECROPPER_UNLOAD';
export const IMAGECROPPER_SET = 'IMAGECROPPER_SET';

// Report Screen
export const REPORTSCREEN_LOAD = 'REPORTSCREEN_LOAD';
export const REPORTSCREEN_UNLOAD = 'REPORTSCREEN_UNLOAD';
export const REPORTSCREEN_SET = 'REPORTSCREEN_SET';

export const ALERTVIEW_LOAD = 'ALERTVIEW_LOAD';
export const ALERTVIEW_LOADALERTS = 'ALERTVIEW_LOADALERTS';
export const ALERTVIEW_ERROR = 'ALERTVIEW_ERROR';
export const ALERTVIEW_UNLOAD = 'ALERTVIEW_UNLOAD';
export const ALERTVIEW_LOADALERTS_PAGE = 'ALERTVIEW_LOADALERTS_PAGE';
export const ALERTVIEW_UPDATE_STATUS = 'ALERTVIEW_UPDATE_STATUS';
export const ALERTVIEW_POLL_STATUS_COUNTS = 'ALERTVIEW_POLL_STATUS_COUNTS';
export const ALERTVIEW_UNLOAD_STATUS_COUNTS = 'ALERTVIEW_UNLOAD_STATUS_COUNTS';
export const ALERTVIEW_DELETE = 'ALERTVIEW_DELETE';

// AlertSubscription Screen
export const ALERTSUBSCRIPTIONSVIEW_LOAD = 'ALERTSUBSCRIPTIONSVIEW_LOAD';
export const ALERTSUBSCRIPTIONSVIEW_UNLOAD = 'ALERTSUBSCRIPTIONSVIEW_UNLOAD';
export const ALERTSUBSCRIPTIONSVIEW_SET = 'ALERTSUBSCRIPTIONSVIEW_SET';
export const ALERTSUBSCRIPTIONSVIEW_DELETE = 'ALERTSUBSCRIPTIONSVIEW_DELETE';

// Customer Survey (Integration)
export const CUSTOMERSURVEY_SEND = 'CUSTOMERSURVEY_SEND';

// Customer Facing Surevy
export const CUSTOMERFACINGSURVEY_LOAD = 'CUSTOMERFACINGSURVEY_LOAD';
export const CUSTOMERFACINGSURVEY_UNLOAD = 'CUSTOMERFACINGSURVEY_UNLOAD';
export const CUSTOMERFACINGSURVEY_SETACCESSKEY = 'CUSTOMERFACINGSURVEY_SETACCESSKEY';

// Hidden Endpoints
export const HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD = 'HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD';
export const HIDDENENDPOINTS_CUSTOMEREMAIL_SET = 'HIDDENENDPOINTS_CUSTOMEREMAIL_SET';

// Survey Search
export const SURVEYSEARCH_LOAD = 'SURVEYSEARCH_LOAD';
export const SURVEYSEARCH_UNLOAD = 'SURVEYSEARCH_UNLOAD';
export const SURVEYSEARCH_SET = 'SURVEYSEARCH_SET';

// QA Survey
export const QASURVEY_LOAD_AND_PARSE = 'QASURVEY_LOAD_AND_PARSE';
export const QASURVEY_UNLOAD = 'QASURVEY_UNLOAD';
export const QASURVEY_SET = 'QASURVEY_SET';

// QA Viewer
export const QAVIEWER_LOAD_AND_PARSE = 'QAVIEWER_LOAD_AND_PARSE';
export const QAVIEWER_LOAD_USERS = 'QAVIEWER_LOAD_USERS';
export const QAVIEWER_UNLOAD = 'QAVIEWER_UNLOAD';
export const QAVIEWER_SET = 'QAVIEWER_SET';

// ZSourceScreen
export const ZSOURCESCREEN_LOAD = 'ZSOURCESCREEN_LOAD';
export const ZSOURCESCREEN_UNLOAD = 'ZSOURCESCREEN_UNLOAD';
export const ZSOURCESCREEN_SET = 'ZSOURCESCREEN_SET';
export const ZSOURCESCREEN_UPDATEUSER = 'ZSOURCESCREEN_UPDATEUSER';

// CreateZSourceScreen
export const CREATEZSOURCESCREEN_LOAD = 'CREATEZSOURCESCREEN_LOAD';
export const CREATEZSOURCESCREEN_UNLOAD = 'CREATEZSOURCESCREEN_UNLOAD';
export const CREATEZSOURCESCREEN_SET = 'CREATEZSOURCESCREEN_SET';

// CreateQaFormScreen
export const CREATEQAFORMSCREEN_LOAD = 'CREATEQAFORMSCREEN_LOAD';
export const CREATEQAFORMSCREEN_UNLOAD = 'CREATEQAFORMSCREEN_UNLOAD';
export const CREATEQAFORMSCREEN_SET = 'CREATEQAFORMSCREEN_SET';

// SurveyFormEditor
export const SURVEYFORMEDITOR_LOAD = 'SURVEYFORMEDITOR_LOAD';
export const SURVEYFORMEDITOR_UNLOAD = 'SURVEYFORMEDITOR_UNLOAD';
export const SURVEYFORMEDITOR_SET = 'SURVEYFORMEDITOR_SET';

// ZSourceSummaryScreen
export const ZSOURCESUMMARYSCREEN_LOAD = 'ZSOURCESUMMARYSCREEN_LOAD';
export const ZSOURCESUMMARYSCREEN_UNLOAD = 'ZSOURCESUMMARYSCREEN_UNLOAD';
export const ZSOURCESUMMARYSCREEN_SET = 'ZSOURCESUMMARYSCREEN_SET';

// CreateQaFormScreen
export const QAFORMSSUMMARYSCREEN_LOAD = 'QAFORMSSUMMARYSCREEN_LOAD';
export const QAFORMSSUMMARYSCREEN_UNLOAD = 'QAFORMSSUMMARYSCREEN_UNLOAD';
export const QAFORMSSUMMARYSCREEN_SET = 'QAFORMSSUMMARYSCREEN_SET';

// ZTestControl
export const ZTESTCONTROL_LOAD = 'ZTESTCONTROL_LOAD';
export const ZTESTCONTROL_UNLOAD = 'ZTESTCONTROL_UNLOAD';
export const ZTESTCONTROL_SET = 'ZTESTCONTROL_SET';

// SurveyFormControl
export const SURVEYFORMCONTROL_LOAD = 'SURVEYFORMCONTROL_LOAD';
export const SURVEYFORMCONTROL_UNLOAD = 'SURVEYFORMCONTROL_UNLOAD';
export const SURVEYFORMCONTROL_SET = 'SURVEYFORMCONTROL_SET';

// RolesScreen
export const ROLESSCREEN_LOAD = 'ROLESSCREEN_LOAD';
export const ROLESSCREEN_UNLOAD = 'ROLESSCREEN_UNLOAD';
export const ROLESSCREEN_SET = 'ROLESSCREEN_SET';

// AURA Survey Suite
export const AURASURVEY_LOAD = 'AURASURVEY_LOAD';
export const AURASURVEY_ANSWERS_LOAD = 'AURASURVEY_ANSWERS_LOAD';
export const AURASURVEY_MAILGUN_EXPORT = 'AURASURVEY_MAILGUN_EXPORT';
export const AURASURVEY_RESPONSE_EXPORT = 'AURASURVEY_RESPONSE_EXPORT';

// FrontlineScreen
export const FRONTLINESCREEN_LOAD = 'FRONTLINESCREEN_LOAD';
export const FRONTLINESCREEN_UNLOAD = 'FRONTLINESCREEN_UNLOAD';
export const FRONTLINESCREEN_SET = 'FRONTLINESCREEN_SET';

// HarmonyScreen
export const HARMONYSCREEN_LOAD = 'HARMONYSCREEN_LOAD';
export const HARMONYSCREEN_UNLOAD = 'HARMONYSCREEN_UNLOAD';
export const HARMONYSCREEN_SET = 'HARMONYSCREEN_SET';

//Portal
export const PORTAL_LOAD = 'PORTAL_LOAD';

//Frontline Aura
export const FRONTLINE_AURA_LOAD = 'FRONTLINE_AURA_LOAD';
export const FRONTLINE_AURA_SET = 'FRONTLINE_AURA_SET';

export const CUSTOMERSURVEY_LOAD = 'CUSTOMERSURVEY_LOAD';
export const CUSTOMERSURVEY_UNLOAD = 'CUSTOMERSURVEY_UNLOAD';
export const CUSTOMERSURVEY_SET = 'CUSTOMERSURVEY_SET';

export const INSIGHTSSCREEN_LOAD = 'INSIGHTSSCREEN_LOAD';
export const INSIGHTSSCREEN_UNLOAD = 'INSIGHTSSCREEN_UNLOAD';
export const INSIGHTSSCREEN_SET = 'INSIGHTSSCREEN_SET';

export const VISIONSCREEN_LOAD = 'INSIGHTSSCREEN_LOAD';
export const VISIONSCREEN_UNLOAD = 'INSIGHTSSCREEN_UNLOAD';
export const VISIONSCREEN_SET = 'INSIGHTSSCREEN_SET';

//////////////////

export const SAMLSCREEN_LOAD = 'SAMLSCREEN_LOAD';
export const SAMLSCREEN_UNLOAD = 'SAMLSCREEN_UNLOAD';
export const SAMLSCREEN_SET = 'SAMLSCREEN_SET';

export const SESSION_LOAD = 'SESSION_LOAD';
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSIONITEMS_LOAD = 'SESSIONITEMS_LOAD';
export const SESSIONITEMS_UNLOAD = 'SESSIONITEMS_UNLOAD';
export const SESSIONITEMS_SET = 'SESSIONITEMS_SET';

export const SURVEYACTIVITYV3SCREEN_LOAD = 'SURVEYACTIVITYV3SCREEN_LOAD';
export const SURVEYACTIVITYV3SCREEN_UNLOAD = 'SURVEYACTIVITYV3SCREEN_UNLOAD';
export const SURVEYACTIVITYV3SCREEN_SET = 'SURVEYACTIVITYV3SCREEN_SET';

export const CALIBRATIONV3SCREEN_LOAD = 'CALIBRATIONV3SCREEN_LOAD';
export const CALIBRATIONV3SCREEN_UNLOAD = 'CALIBRATIONV3SCREEN_UNLOAD';
export const CALIBRATIONV3SCREEN_SET = 'CALIBRATIONV3SCREEN_SET';

export const SURVEYSSCREEN_LOAD = 'SURVEYSSCREEN_LOAD';
export const SURVEYSSCREEN_UNLOAD = 'SURVEYSSCREEN_UNLOAD';
export const SURVEYSSCREEN_SET = 'SURVEYSSCREEN_SET';

export const TEAMSSCREEN_LOAD = 'TEAMSSCREEN_LOAD';
export const TEAMSSCREEN_UNLOAD = 'TEAMSSCREEN_UNLOAD';
export const TEAMSSCREEN_SET = 'TEAMSSCREEN_SET';

export const USERSSCREEN_LOAD = 'USERSSCREEN_LOAD';
export const USERSSCREEN_UNLOAD = 'USERSSCREEN_UNLOAD';
export const USERSSCREEN_SET = 'USERSSCREEN_SET';

export const SYSTEMDASHBOARDSCREEN_LOAD = 'SYSTEMDASHBOARDSCREEN_LOAD';
export const SYSTEMDASHBOARDSCREEN_UNLOAD = 'SYSTEMDASHBOARDSCREEN_UNLOAD';
export const SYSTEMDASHBOARDSCREEN_SET = 'SYSTEMDASHBOARDSCREEN_SET';

export const QADASHBOARDSCREEN_LOAD = 'QADASHBOARDSCREEN_LOAD';
export const QADASHBOARDSCREEN_UNLOAD = 'QADASHBOARDSCREEN_UNLOAD';
export const QADASHBOARDSCREEN_SET = 'QADASHBOARDSCREEN_SET';

export const AGENTSURVEYSCREEN_LOAD = 'AGENTSURVEYSCREEN_LOAD';
export const AGENTSURVEYSCREEN_UNLOAD = 'AGENTSURVEYSCREEN_UNLOAD';
export const AGENTSURVEYSCREEN_SET = 'AGENTSURVEYSCREEN_SET';

export const COACHINGDASHBOARD_LOAD = 'COACHINGDASHBOARD_LOAD';
export const COACHINGDASHBOARD_UNLOAD = 'COACHINGDASHBOARD_UNLOAD';
export const COACHINGDASHBOARD_SET = 'COACHINGDASHBOARD_SET';

export const COMCASTLIVEAGENTSURVEY_LOAD = 'COMCASTLIVEAGENTSURVEY_LOAD';
export const COMCASTLIVEAGENTSURVEY_UNLOAD = 'COMCASTLIVEAGENTSURVEY_UNLOAD';
export const COMCASTLIVEAGENTSURVEY_SET = 'COMCASTLIVEAGENTSURVEY_SET';

export const TEAMDASHBOARDSCREEN_LOAD = 'TEAMDASHBOARDSCREEN_LOAD';
export const TEAMDASHBOARDSCREEN_UNLOAD = 'TEAMDASHBOARDSCREEN_UNLOAD';
export const TEAMDASHBOARDSCREEN_SET = 'TEAMDASHBOARDSCREEN_SET';